import { motion } from "framer-motion";
import AnimatedHeading from "../../animations/AnimatedHeading";

const contacts = [
  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        width="26"
        height="26"
        fill="var(--brand-primary)"
      >
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
      </svg>
    ),
    title: "Our Location",
    lines: [
      "Kolathia Square, near sri sai garden, uco bank top floor, khandagiri, Bhubaneswar, 751030",
    ],
    highlight: null,
  },

  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        width="26"
        height="26"
        fill="var(--brand-primary)"
      >
        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
      </svg>
    ),
    title: "Email us",
    lines: ["web.bocket@gmail.com"],
    highlight: null,
  },

  {
    icon: (
      <svg
        viewBox="0 0 24 24"
        width="26"
        height="26"
        fill="var(--brand-primary)"
      >
        <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.61 21 3 13.39 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.58a1 1 0 01-.24 1.01l-2.21 2.2z" />

        <path
          d="M17 1v4M19 3h-4"
          stroke="var(--brand-primary)"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    ),
    title: "Call us",
    lines: ["+91 83288 92097"],
    highlight: null,
  },
];

const fadeUp = (delay = 0) => ({
  hidden: {
    opacity: 0,
    y: 24,
  },

  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      delay,
      ease: [0.22, 1, 0.36, 1],
    },
  },
});

export default function ContactInfo() {
  return (
    <section
      className="
        w-full
        overflow-hidden
        px-4
        py-6
        min-[375px]:px-5
        min-[375px]:py-7
        sm:px-6
        sm:py-9
        md:px-10
        md:py-11
        lg:px-14
        lg:py-20
      "
      style={{
        backgroundColor: "var(--bg-primary)",
        color: "var(--text-primary)",
      }}
    >
      <div className="mx-auto w-full max-w-7xl">

        {/* =========================================================
            HEADER
        ========================================================== */}

        <div
          className="
            mb-5
            w-full
            text-center
            min-[375px]:mb-6
            sm:mb-7
            md:mb-8
            lg:mb-12
          "
        >
          {/* =====================================================
              SECTION LABEL
          ===================================================== */}

          <motion.p
            initial={{
              opacity: 0,
              y: 12,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{
              once: true,
            }}
            transition={{
              duration: 0.4,
            }}
            className="
              mb-2
              text-[10px]
              font-bold
              uppercase
              tracking-[0.20em]
              brand-color
              min-[375px]:mb-2.5
              min-[375px]:text-[11px]
              min-[375px]:tracking-[0.23em]
              sm:mb-3
              sm:text-xs
              sm:tracking-[0.28em]
              md:text-sm
              lg:mb-6
              lg:tracking-[0.3em]
            "
          >
            [ CONTACT INFO ]
          </motion.p>

          {/* =====================================================
              HEADING
          ===================================================== */}

          <AnimatedHeading
            as="h2"
            parts={["Reach Out Us Now!"]}
            className="
              mx-auto
              w-full
              max-w-4xl
              font-saira
              text-2xl
              font-semibold
              leading-[1.12]
              theme-text-primary
              min-[375px]:text-[27px]
              sm:text-3xl
              md:text-4xl
              lg:mb-6
              lg:text-6xl
              lg:leading-tight
            "
          />
        </div>

        {/* =========================================================
            CONTACT CARDS
        ========================================================== */}

        <div
          className="
            grid
            w-full
            grid-cols-1
            gap-3
            min-[375px]:gap-4
            sm:grid-cols-2
            sm:gap-5
            md:gap-6
            lg:grid-cols-3
            lg:gap-5
          "
        >
          {contacts.map((c, i) => (
            <motion.div
              key={i}
              variants={fadeUp(i * 0.09)}
              initial="hidden"
              whileInView="visible"
              viewport={{
                once: true,
                amount: 0.2,
              }}
              className="
                contact-card
                flex
                min-w-0
                flex-col
                items-center
                gap-3
                px-4
                py-5
                text-center
                min-[375px]:gap-4
                min-[375px]:px-5
                min-[375px]:py-6
                sm:px-6
                sm:py-7
                md:px-7
                md:py-8
                lg:gap-6
                lg:px-8
                lg:py-10
              "
            >
              {/* =================================================
                  ICON
              ================================================== */}

              <div
                className="
                  flex
                  h-12
                  w-12
                  shrink-0
                  items-center
                  justify-center
                  rounded-full
                  theme-card-secondary
                  border
                  theme-border
                  min-[375px]:h-14
                  min-[375px]:w-14
                  sm:h-16
                  sm:w-16
                "
              >
                {c.icon}
              </div>

              {/* =================================================
                  CONTENT
              ================================================== */}

              <div
                className="
                  min-w-0
                  w-full
                  max-w-md
                "
              >
                <h3
                  className="
                    syne
                    mb-1.5
                    break-words
                    text-base
                    font-bold
                    leading-tight
                    theme-text-primary
                    min-[375px]:mb-2
                    min-[375px]:text-lg
                    sm:mb-2.5
                    lg:mb-3
                  "
                >
                  {c.title}
                </h3>

                {c.lines.map((line, j) => (
                  <p
                    key={j}
                    className="
                      dm
                      break-words
                      text-[12px]
                      leading-5
                      theme-text-muted
                      min-[375px]:text-[13px]
                      min-[375px]:leading-6
                      sm:text-sm
                      sm:leading-relaxed
                      md:text-[15px]
                      lg:text-sm
                    "
                    style={{
                      overflowWrap: "anywhere",
                      wordBreak: "break-word",
                    }}
                  >
                    {line}
                  </p>
                ))}

                {c.highlight && (
                  <p
                    className="
                      syne
                      mt-1
                      text-xs
                      font-bold
                      brand-color
                      min-[375px]:text-sm
                    "
                  >
                    {c.highlight}
                  </p>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* =========================================================
          COMPONENT-SPECIFIC STYLES
      ========================================================== */}

      <style>{`
        .syne {
          font-family: "Syne", sans-serif;
        }

        .dm {
          font-family: "DM Sans", sans-serif;
        }

        .contact-card {
          background-color: var(--card-bg);
          border: 1px solid var(--border-primary);
          border-radius: 16px;
          transition:
            border-color 0.25s ease,
            background-color 0.25s ease,
            transform 0.25s ease,
            box-shadow 0.25s ease;
        }

        .contact-card:hover {
          background-color: var(--card-bg-secondary);
          border-color: var(--brand-primary);
          box-shadow: 0 10px 30px var(--shadow-color);
        }

        @media (hover: hover) and (pointer: fine) {
          .contact-card:hover {
            transform: translateY(-3px);
          }
        }
      `}</style>
    </section>
  );
}